import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/pacer-emails/creator/{creatorId}/get-pacer-emails']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const PATH_TEMPLATE = '/pacer-emails/creator/{creatorId}/get-pacer-emails';

const getPacerEmailsByCreatorId = async ({
  creatorId,
  startDate,
  endDate,
  sortDir,
  searchText,
  page,
  filterByNoticeTypes,
  filterByWorkflowNames,
}: Input & { filterByNoticeTypes?: string }): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path, {
    params: {
      endDate,
      filterByNoticeTypes,
      filterByWorkflowNames,
      page,
      searchText,
      sortDir,
      startDate,
    },
  });
  return response.data;
};

export default getPacerEmailsByCreatorId;
